import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { emptyShootoutAttempts } from 'shared/utils/shootout';
import { resetGameInfo, syncGameInfo } from './actions';
import { GameInfoSliceState } from './game-info';
import { resetTeamStats } from './utils/reset-team-stats';

type ReducerBuilder = ActionReducerMapBuilder<GameInfoSliceState>;

export function createSyncDataReducer(builder: ReducerBuilder) {
  builder.addCase(syncGameInfo.pending, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = true;
    state.error = undefined;
  });

  builder.addCase(syncGameInfo.fulfilled, (state, action) => {
    state.isSynchronize = true;
    state.isSynchronization = false;
    state.error = undefined;

    state.goals = action.payload.goals;
    state.fouls = action.payload.fouls;
    state.shootout.attempts = action.payload.shootout;

    // TODO Сделать маппер
    const match = action.payload.gameInfo?.match;
    if (match) {
      state.match = {
        ...match,
        date: match.dateInfo.fullDate,
      };
    }

    const teams = action.payload.gameInfo?.teams;
    if (teams) {
      const first = teams.firstTeam;
      const second = teams.secondTeam;
      if (!first) {
        console.warn({ 'No first team': teams });
      } else if (!second) {
        console.warn({ 'No second team': teams });
      } else {
        state.teams = {
          first: { ...first },
          second: { ...second },
        };
      }
    }

    const organizer = action.payload.gameInfo?.organizer;
    if (organizer) {
      state.organizer = { ...organizer };
    }

    const championship = action.payload.gameInfo?.championship;
    if (championship) {
      state.championship = { ...championship };
    }

    const sportType = action.payload.gameInfo?.sportType;
    if (sportType) {
      state.sportType = sportType;
    }

    console.debug({ event: 'data synchronized' });
  });

  builder.addCase(syncGameInfo.rejected, (state, action) => {
    state.isSynchronize = false;
    state.isSynchronization = false;
    state.error = action.payload as string;

    console.error('Failed to synchronize game info', action.error);
  });
}

export function createResetAllReducer(builder: ReducerBuilder) {
  builder.addCase(resetGameInfo, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = false;

    state.goals = { first: 0, second: 0 };
    state.fouls = {};
    // Серию обнуляем вместе со всем остальным: ниже чистится `parsedEventsId`, и
    // пришедшая следом хронология разбирается заново — сохранённые удары удвоились бы.
    state.shootout.attempts = emptyShootoutAttempts();

    if (state.teams?.first.members) {
      state.teams.first = resetTeamStats(state.teams.first);
    }
    if (state.teams?.second.members) {
      state.teams.second = resetTeamStats(state.teams.second);
    }

    state.parsedEventsId = [];
  });
}
